module.exports = __webpack_public_path__ + "img/mainPicture.86bb5471.png";